import { getAllBorrowers, getAssociatedBorrowers } from "../api/BrokerApi";
import { getMockAllBorrowers, getMockAssociatedBorrowers } from "../api/mock/MockBrokerApi";
import { BPQuestionLabels } from "../components/broker/BPQuestionLabels";
import { GlobalConstants } from "../components/constants/GlobalConstants";
import { deepCopy, handleErrorResponse } from "../Helpers";
import { handleApiPromise } from "./GlobalHelper";

export const handlePurchaseOrRefinanceOptions = (options) => {
  const purchaseOrRefinanceOptions = options ? deepCopy(options) : [];
  return purchaseOrRefinanceOptions?.reduce((result, option) => {
    if (option.id !== GlobalConstants.PurchaseOrRefinanceOptionIds.REFINANCE_INTERNAL) {
      if (option.id === GlobalConstants.PurchaseOrRefinanceOptionIds.REFINANCE_EXTERNAL) {
        const externalOption = option;
        externalOption.name = "Refinance";
        result.push(externalOption);
      }
      else {
        result.push(option);
      }
    }

    return result;
  }, []);  
};

export const handleRefinanceOptions = (options) => {
  const refinanceOptions = options ? deepCopy(options) : [];
  return refinanceOptions?.reduce((result, option) => {
    if (option.id === GlobalConstants.PurchaseOrRefinanceOptionIds.REFINANCE_INTERNAL) {
      const externalOption = option;
      externalOption.name = `Internal (${BPQuestionLabels.RefinanceInternalDescription})`;
      result.push(externalOption);
    }
    else if (option.id === GlobalConstants.PurchaseOrRefinanceOptionIds.REFINANCE_EXTERNAL) {
      const externalOption = option;
      externalOption.name = `External (${BPQuestionLabels.RefinanceExternalDescription})`;
      result.push(externalOption);
    }

    return result;
  }, []);  
};

export const handleAssociatedOrganizationContactId = (obj, brokerOrganizationContactId = null) => {
  if (brokerOrganizationContactId) {
    return brokerOrganizationContactId;
  }
  else if (obj.brokerOrganizationContactId) {
    return obj.brokerOrganizationContactId;
  }
  else if (obj.loanOfficerOrganizationContactId) {
    return obj.loanOfficerOrganizationContactId;
  }

  return null;
};

export const handleAssociatedBorrowers = async (
  isAllBorrowers, 
  organizationContactId,
  setAssociatedBorrowers, 
  proxyUser, 
  setIsMessage, 
  setErrorResponse
  ) => {
  let borrowers = [];
  if (isAllBorrowers) {
    borrowers = await handleApiPromise(
      () => getAllBorrowers(proxyUser.id),
      () => getMockAllBorrowers(),
      (response) => handleErrorResponse(response, setIsMessage, setErrorResponse)
    ) || [];
  }
  else {
    borrowers = await handleApiPromise(
      () => getAssociatedBorrowers(organizationContactId, proxyUser.id),
      () => getMockAssociatedBorrowers(),
      (response) => handleErrorResponse(response, setIsMessage, setErrorResponse)
    ) || [];
  }

  setAssociatedBorrowers(borrowers);
  return borrowers;
};